<script lang="ts">
  import AutoComplete from "primevue/autocomplete";
  import Message from "primevue/message";
  import { useField } from "vee-validate";

  Object.values(AutoComplete.components).forEach((component) => {
    component.compatConfig = {
      MODE: 3,
      COMPONENT_V_MODEL: false,
    };
  });

  AutoComplete.compatConfig = {
    MODE: 3,
    COMPONENT_V_MODEL: false,
  };
  import { ref } from "vue";

  export default {
    components: {
      AutoComplete,
      Message,
    },
    props: {
      name: {
        type: String,
        required: true,
      },
      label: {
        type: String,
        required: false,
      },
      required: {
        type: Boolean,
        required: false,
      },
      virtualScrollerOptions: {
        type: Object,
        required: false,
      },
      dropdown: {
        type: Boolean,
        required: false,
      },
      suggestions: {
        type: Array,
        required: true,
      },
      complete: {
        type: Function,
        required: true,
      },
      optionLabel: {
        type: String,
        required: false,
      },
      optionSelect: {
        type: Function,
        required: false,
      },
      placeholder: {
        type: String,
        required: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      invalid: {
        type: Boolean,
        default: false,
      },
      inputClass: {
        type: String,
        required: false,
      },
      openOptions: {
        type: Function,
        required: false,
      },
    },
    setup(props) {
      const { value: localValue, errorMessage, setValue } = useField(() => props.name);
      const autoCompleteRef = ref();

      const handleHide = () => {
        setValue("");
      };

      const handleFocus = () => {
        if (props.openOptions) {
          props.openOptions?.();

          if (autoCompleteRef.value) {
            autoCompleteRef.value.show();
          }
        }
      };

      return {
        localValue,
        errorMessage,
        autoCompleteRef,
        handleHide,
        handleFocus,
      };
    },
  };
</script>

<template>
  <div class="flex flex-col gap-[4px]">
    <label v-if="label" class="text-[14px] font-normal">
      {{ label }}
      <span v-if="required" class="text-[#FF55C6]">*</span>
    </label>
    <AutoComplete
      ref="autoCompleteRef"
      v-bind="{ ...$props, ...$attrs }"
      @complete="complete"
      @option-select="optionSelect"
      @focus="handleFocus"
      v-model="localValue"
      :name="name"
      :invalid="invalid || !!errorMessage"
      :inputClass="inputClass"
      emptySearchMessage="Geen resultaten gevonden"
    >
      <template v-for="(_, name) in $slots" v-slot:[name]="slotData">
        <slot :name="name" v-bind="slotData"></slot>
      </template>
    </AutoComplete>
    <Message v-if="errorMessage" severity="error" size="small" variant="simple" :text="errorMessage" />
  </div>
</template>

<style scoped>
  :deep(.p-autocomplete-input) {
    @apply w-full;
  }
</style>
